__turbopack_context__.v({
  "className": "libre_baskerville_5d9b1e52-module__aCEK6W__className",
});
